import { CSSProperties } from 'react';

import { WidgetSchema, WidgetSchemaWithContent } from '@/entities/widget';

import { useResponsive } from '@/shared/lib';
import { CarouselItem } from '@/shared/ui';

interface SlidesListProps {
  slides: WidgetSchemaWithContent[];
  onSlideClick: (slide: WidgetSchema, index: number) => void;
}

const SlidesList = ({ slides, onSlideClick }: SlidesListProps) => {
  const { isDesktop } = useResponsive();

  const handleClick = (slide: WidgetSchema, index: number) => () => {
    onSlideClick(slide, index);
  };

  const getFlexBasis = (
    slide: WidgetSchemaWithContent,
  ): CSSProperties['flexBasis'] => {
    if (!isDesktop) return 'auto';
    return `${String(slide.width)}px`;
  };

  const list = slides.map((slide, index) => {
    if (index === 0) {
      return (
        <CarouselItem
          key={slide.id}
          id={slide.id}
          onClick={handleClick(slide, index)}
          style={{
            flexBasis: getFlexBasis(slide),
            marginLeft: isDesktop
              ? `calc(50% - ${String(slide.width / 2)}px)`
              : `calc(50% - 163px)`,
            maxWidth: !slide.withMobile && !isDesktop ? '327px' : 'auto',
            width:
              !isDesktop && slide.withMobile
                ? 'calc(100vw-8px)'
                : 'calc(100vw-64px)',
          }}
          className="relative min-w-0 pl-0"
        >
          {slides[0].content}
        </CarouselItem>
      );
    }

    const isLastSlide = index + 1 === slides.length;

    return (
      <CarouselItem
        key={slide.id}
        id={slide.id}
        onClick={handleClick(slide, index)}
        style={{
          flexBasis: getFlexBasis(slide),
          marginRight: isLastSlide
            ? `calc(45% - ${String(slide.width / 2)}px)`
            : '0',
          maxWidth: !slide.withMobile && !isDesktop ? '327px' : 'auto',
          width:
            !isDesktop && slide.withMobile
              ? 'calc(100vw-8px)'
              : 'calc(100vw-64px)',
        }}
        className="relative min-w-0 pl-0"
      >
        {slide.content}
      </CarouselItem>
    );
  });

  return list;
};

export default SlidesList;
